import React from 'react'

import {    
    Container   
  } from '@mui/material';
import BudgetTable from './BudgetTable'

const  SimpleReactFileUpload =()=> {  
    return (
      
      <Container maxWidth={false}>    
    
       <BudgetTable />  
       
      </Container>
      
   )
  }
export default SimpleReactFileUpload